import type { Nullable } from '@gov-nx/core/types/helpers.types';
import { isNonEmptyString } from '@gov-nx/core/types/helpers.types';
import {
	AUTHORIZATION_ERROR_PARAM,
	AUTHORIZATION_ID_PARAM,
	AUTHORIZATION_RESULT_FAILURE_VALUE,
	AUTHORIZATION_RESULT_PARAM,
	AUTHORIZATION_RESULT_SUCCESS_VALUE,
	PARAM_CANCELED_VALUE,
} from './constants';

export enum AuthorizationOutcome {
	Cancelled = 'CANCELLED',
	Success = 'SUCCESS',
	Failure = 'FAILURE',
	Unknown = 'UNKNOWN',
}

export type AuthorizationParamReader = (name: string) => Nullable<string>;

export const resolveAuthorizationOutcome = (
	getParam: AuthorizationParamReader
): AuthorizationOutcome => {
	if (!isNonEmptyString(getParam(AUTHORIZATION_ID_PARAM))) {
		return AuthorizationOutcome.Unknown;
	}

	if (getParam(AUTHORIZATION_ERROR_PARAM) === PARAM_CANCELED_VALUE) {
		return AuthorizationOutcome.Cancelled;
	}

	switch (getParam(AUTHORIZATION_RESULT_PARAM)) {
		case AUTHORIZATION_RESULT_SUCCESS_VALUE:
			return AuthorizationOutcome.Success;
		case AUTHORIZATION_RESULT_FAILURE_VALUE:
			return AuthorizationOutcome.Failure;
		default:
			return AuthorizationOutcome.Unknown;
	}
};
